export default {
    meta: {
        title: '加盟商详情',
        url: '/fishtogether/franchiseelist',
        urlName: '鱼你加盟商管理',
    }
};
